<template src="./atividade.html"></template>

<style lang="less" src="./atividade.less"></style>

<script>
import VWidget from "@/components/VWidget";
export default {
  components: {
    VWidget
  },
  data: function() {
    return {
      modoCadastro: !this.$route.params.id,
      setores: [],
      loading: false,
      erro: false,
      mensagemDeErro: "",
      model: {
        Descricao: "",
        SetoresId: []
      }
    };
  },
  methods: {
    getAtividade() {
      this.$http
        .get("/atividades/" + this.$route.params.id)
        .then(result => {
          this.model = result.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getSetores() {
      this.$http
        .get("/setores")
        .then(result => {
          this.setores = result.data.lista;
        })
        .catch(err => {
          console.log(err);
        });
    },
    saveAtividade() {
      if (this.modoCadastro) this.new();
      else this.edit();
    },
    edit() {
      this.$http
        .put("/atividades/" + this.$route.params.id, this.model)
        .then(result => {
          this.model = result.data;
          this.$store.state.notification.success = true;
          this.$store.state.notification.text = "Atividade editada com sucesso";
          this.$router.push("/atividades");
        })
        .catch(err => {
          this.loading = false;
          this.erro = true;
          this.mensagemDeErro = err.response.data.erros.join(". ");
        });
    },
    new() {
      this.$http
        .post("/atividades", this.model)
        .then(result => {
          this.model = result.data;
          this.$store.state.notification.success = true;
          this.$store.state.notification.text =
            "Atividade cadastrada com sucesso";
          this.$router.push("/atividades");
        })
        .catch(err => {
          this.loading = false;
          this.erro = true;
          this.mensagemDeErro = err.response.data.erros.join(". ");
        });
    }
  },
  mounted: function() {
    this.getSetores();
    if (!this.modoCadastro) {
      this.getAtividade();
    }
  }
};
</script>
